(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnails-collection-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnails-offer-accordion')) {
    customElements.define('bnails-offer-accordion', class extends HTMLElement {
      connectedCallback() {
        if (this.onSummaryClick) return;
        this.details = this.querySelector('.bnails-collection-offer__details');
        this.summary = this.querySelector('.bnails-collection-offer__summary');
        if (!this.details || !this.summary) return;
        this.expanded = this.details.open;
        this.summary.setAttribute('aria-expanded', String(this.expanded));
        this.onSummaryClick = this.toggleOffer.bind(this);
        this.summary.addEventListener('click', this.onSummaryClick);
      }

      disconnectedCallback() {
        this.summary?.removeEventListener('click', this.onSummaryClick);
        this.animation?.cancel();
        if (this.details) this.finishToggle();
        this.onSummaryClick = null;
      }

      finishToggle() {
        this.details.open = this.expanded;
        this.details.style.height = '';
        this.details.style.overflow = '';
        this.animation = null;
      }

      toggleOffer(event) {
        event.preventDefault();
        const startHeight = this.details.getBoundingClientRect().height;
        this.expanded = !this.expanded;
        this.animation?.cancel();
        this.animation = null;
        this.summary.setAttribute('aria-expanded', String(this.expanded));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !this.details.animate) {
          this.finishToggle();
          return;
        }

        this.details.style.height = '';
        this.details.style.overflow = 'hidden';
        this.details.open = true;
        const endHeight = this.expanded
          ? this.details.getBoundingClientRect().height
          : this.summary.getBoundingClientRect().height;
        const animation = this.details.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: this.expanded ? 440 : 360, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        this.animation = animation;
        animation.onfinish = () => {
          if (this.animation === animation) this.finishToggle();
        };
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnails-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnails-community')) {
    class BnailsCommunity extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-gallery-track]');
        this.photos = Array.from(this.querySelectorAll('[data-gallery-photo]'));
        this.dialog = this.querySelector('[data-gallery-dialog]');
        this.fullImage = this.querySelector('[data-dialog-image]');
        this.caption = this.querySelector('[data-dialog-caption]');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        if (!this.track || !this.dialog || !this.photos.length) return;
        this.querySelector('[data-gallery-controls]').hidden = this.photos.length < 2;
        this.previous.addEventListener('click', () => this.scrollGallery(-1), options);
        this.next.addEventListener('click', () => this.scrollGallery(1), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.photos.forEach((photo, index) => {
          photo.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof this.dialog.showModal !== 'function') return;
            event.preventDefault();
            this.returnFocus = photo;
            this.showPhoto(index);
            this.dialog.showModal();
            this.querySelector('[data-dialog-close]').focus();
          }, options);
        });
        this.querySelector('[data-dialog-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-dialog-previous]').addEventListener('click', () => this.showPhoto(this.activeIndex - 1), options);
        this.querySelector('[data-dialog-next]').addEventListener('click', () => this.showPhoto(this.activeIndex + 1), options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.track);
        this.updateNavigation();
      }

      scrollGallery(direction) {
        const card = this.track.querySelector('.bnails-community__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        this.track.scrollBy({ left: direction * sign * (card.getBoundingClientRect().width + gap), behavior });
      }

      updateNavigation() {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = position <= 2;
        this.next.disabled = maximum - position <= 2;
      }

      showPhoto(index) {
        this.activeIndex = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.activeIndex];
        this.fullImage.src = photo.href;
        this.fullImage.alt = photo.dataset.photoAlt || '';
        this.caption.textContent = this.dataset.imageCount.replace('[current]', String(this.activeIndex + 1)).replace('[total]', String(this.photos.length));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        this.controller = null;
      }
    }
    customElements.define('bnails-community', BnailsCommunity);
  }

  } catch(e) { console.error(e); }
})();
})();
